import { render, staticRenderFns } from "./EventCalendarView.vue?vue&type=template&id=4ecd17a8&scoped=true&"
import script from "./EventCalendarView.vue?vue&type=script&lang=js&"
export * from "./EventCalendarView.vue?vue&type=script&lang=js&"
import style0 from "./EventCalendarView.vue?vue&type=style&index=0&id=4ecd17a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecd17a8",
  null
  
)

export default component.exports